var ctUserSettingsComponent;
(function ($) {
 	$.fn.ctUserSettingsComponent = function(options) {
		var $ctUserSettingsElm = $(this);
		var options = {};
		var defaultSettingItems = [
			{
				"key": "language",
				"languageKey": "mySettings.language",
				"value": getLocalStorage("myCapitechUserSettings").language
			},{
				"key": "selectCurrentDateOnStartup",
				"languageKey": "mySettings.selectCurrentDateOnStartup",
				"value": "false"
			},{
				"key": "useNativeTimeInput",
				"languageKey": "mySettings.useNativeTimeInputIfDeviceHasSupport",
				"value": "true"
			}
		]
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			options = { 
				extend: {
					"{root}": function(userSettingItems) {
						userSettingItemTemplate = function (userSettingItem) {
							return 'user-setting-template-' + userSettingItem.type();
						};
					},
					"{root}.userSettingItems[i]": function(userSettingItem){
						userSettingItem.type = ko.computed(function() {
							if (userSettingItem.key() === "language") {
								return "language";
							} else if (userSettingItem.key() === "selectCurrentDateOnStartup") {
								return "boolean-select-current-date-on-startup";
							} else if (userSettingItem.key() === "useNativeTimeInput") {
								return "boolean";
							} else {
								return 'string';
							}
						}, userSettingItem);
						userSettingItem.translatedKeyText = ko.computed(function() {
							return getResource(userSettingItem.languageKey());
						}, userSettingItem);
						userSettingItem.translatedValueText = ko.computed(function() {
							if (userSettingItem.key() === "selectCurrentDateOnStartup") {
								return getResource('mySettings.selectCurrentDateOnStartup' + capitalizeFirstLetter(userSettingItem.value()));
							}
							return getResource('mySettings.' + userSettingItem.value());
						}, userSettingItem);
						userSettingItem.isEditing = ko.observable(false);
						userSettingItem.oldValue = ko.observable("");
						userSettingItem.editUserSetting = function() {
							userSettingItem.oldValue(userSettingItem.value());
							userSettingItem.isEditing(true);
						};
						userSettingItem.saveUserSetting = function(_self, evt) {
							evt.preventDefault();
							var success = function success(data, textStatus, jqXHR) {
								loaderIndicator(false);
								if (data.success == true) {
									userSettingItem.isEditing(false);
									// Update myCapitechUserSettings in localstorage
									var tempSettings = getLocalStorage("myCapitechUserSettings");
									tempSettings[userSettingItem.key()] = userSettingItem.value();
									setLocalStorage("myCapitechUserSettings", tempSettings);
									
									// Update myCapitechSettings in localstorage if language has been changed
									if (userSettingItem.key() === "language") {
										var tempMyCapitechSettings = getLocalStorage("myCapitechSettings");
										tempMyCapitechSettings.language = userSettingItem.value();
										tempMyCapitechSettings.languageShort = getShortLanguageCode(tempMyCapitechSettings.language);
										_appSettingsObj.language = userSettingItem.value();
										setLocalStorage("myCapitechSettings", tempMyCapitechSettings);
										getAllLocalizations();
									}
								} else {
									sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
								}
							};
							var error = function error(jqXHR, textStatus, errorThrown) {
								loaderIndicator(false);
								sweetAlert("Error", errorThrown, "error");
							};
							loaderIndicator(true);
							_api.upsertMyCapitechSetting_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), userSettingItem.key(), userSettingItem.value());
						};
						userSettingItem.cancelEditSetting = function() {
							userSettingItem.isEditing(false);
							userSettingItem.value(userSettingItem.oldValue());
						};
					}
				}
			}
			getUserSettings();
		}
		
		function getUserSettings() {
			var success = function success(data, textStatus, jqXHR) {
				var modelData = {};
				loaderIndicator(false);
				if (data.success == true) {
					modelData.userSettingItems = defaultSettingItems;
					// Insert default settings if they dont exists
					defaultSettingItems.forEach(function(defaultSettingItem) {
						var existsInServerSettings = false;
						for (var index = 0; index < data.content.length; index++) {
							var serverSettingItem = data.content[index];
							if (serverSettingItem.key.toLowerCase() === defaultSettingItem.key.toLowerCase()) {
								defaultSettingItem.value = serverSettingItem.value;
								break;
							}
						}
					});
					ctUserSettingsComponent = ko.viewmodel.fromModel(modelData, options);
					ctUserSettingsComponent.userSettingItems.sort(_sortUserSettingsASC);
					$('*[data-ko-bind="ctUserSettingsModel"]').each(function(index, obj) {
						ko.applyBindings(ctUserSettingsComponent, obj);
					});
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator(true);
			_api.getMyCapitechSettings_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME));
		}

		function getAllLocalizations() {
			_api.getAllLocalizations_POST(
				function(data, textStatus, jqXHR) {
					if (data.success == true) {
						var languages = getLocalStorage("myCapitechLanguages");
						languages[_appSettingsObj.language] = data.content;
						setLocalStorage('myCapitechLanguages', languages);
						window.location.reload(false);
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				},
				function(jqXHR, textStatus, errorThrown) {
					displayAjaxErrorAlert(jqXHR);
				},
				getLocalStorage("myCapitechSettings").languageShort,
				null
			);
		}

		function _sortUserSettingsASC(a ,b) {
			return a.key() < b.key() ? -1 : 1;
		}

		function capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));